import { hot } from 'react-hot-loader/root';
import App from './features/app';

// react-hot-loader doesn't have any effect in production mode, so no need to
// check for it here
export default hot(App);
